import React from "react";

const ConsultationFooter = () => {
  return (
    <>
      <div
        className="text-center text-footer-center"
        style={{
          color: "#717171",
          fontSize: "14px",
          fontFamily: "Poppins",
          marginTop: "20px",
        }}
      >
        Copyright 2021 ©{" "}
        <a
          className="lastlink"
          style={{ color: "#01a7c2", fontWeight: 600 }}
          href="/"
        >
          SecondLookOrtho
        </a>{" "}
        | All Rights Reserved
      </div>
    </>
  );
};

export default ConsultationFooter;
